(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary-products"] && !Shopify.designMode) return;
  try {
    
  class ComplementaryWithFallback extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      if (this.children.length > 0) {
        this.dataset.loaded = 'true';
        return;
      }
      this.load();
    }

    async load() {
      this.dataset.loaded = 'true';
      const { sectionId, productId, limit, fallbackIntent } = this.dataset;
      let html = await this.fetchSection(sectionId, productId, limit, 'complementary');
      if (!html && fallbackIntent) {
        html = await this.fetchSection(sectionId, productId, limit, fallbackIntent);
      }
      if (html) this.innerHTML = html;
    }

    async fetchSection(sectionId, productId, limit, intent) {
      try {
        const params = new URLSearchParams({
          section_id: sectionId,
          product_id: productId,
          limit,
          intent,
        });
        const res = await fetch(`/recommendations/products?${params}`);
        if (!res.ok) return null;
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const wrapper = doc.querySelector('complementary-with-fallback');
        const html = wrapper && wrapper.innerHTML.trim();
        return html || null;
      } catch (_) {
        return null;
      }
    }
  }

  if (!customElements.get('complementary-with-fallback')) {
    customElements.define('complementary-with-fallback', ComplementaryWithFallback);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderSidebarMultiDrawer {
    static init() {
      document.querySelectorAll('header-sidebar-collapsible-panel').forEach((panel) => {
        if (panel.dataset.multiDrawerReady) return;
        panel.dataset.multiDrawerReady = 'true';
        panel.addEventListener('click', (event) => {
          const button = event.target.closest('[data-action="navigate-to-panel"]');
          if (!button || !panel.contains(button)) return;
          const targetId = button.getAttribute('aria-controls');
          if (!targetId) return;
          panel.setAttribute('aria-activedescendant', targetId);
        });
      });
    }
  }

  if (document.readyState !== 'loading') {
    HeaderSidebarMultiDrawer.init();
  } else {
    document.addEventListener('DOMContentLoaded', () => HeaderSidebarMultiDrawer.init());
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('header-sidebar-collapsible-panel')) {
      HeaderSidebarMultiDrawer.init();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-hover-value]').forEach(hoverElement => {
    hoverElement.addEventListener('mouseover', () => {
      const { hoverValue, hoverOption } = hoverElement.dataset;
      const hoveredElements = document.querySelectorAll(`[data-hovered-value="${hoverOption}"]`);

      hoveredElements.forEach(el => {
        el.textContent = hoverValue;
      });
    });

    hoverElement.addEventListener('mouseout', () => {
      const { hoverOption } = hoverElement.dataset;
      const hoveredElements = document.querySelectorAll(`[data-hovered-value="${hoverOption}"]`);

      hoveredElements.forEach(el => {
        el.textContent = el.dataset.hoveredDefaultValue || '';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
